import { CLEAN_SEARCH } from "../../utils/constantes";

const cleanSearch = () => {
    return{
        type: CLEAN_SEARCH,
    }
};

export default cleanSearch;